import { Text } from '@hhgtech/hhg-components'
import dayjs from 'dayjs'
import { useIntl } from 'react-intl'

import { CalendarMarker, CalendarRange } from 'interfaces/types'

import {
  StyledCalendarModal,
  StyledCalendarModalCalendar,
  StyledCalendarModalCloseIcon,
  StyledCalendarModalContent,
  StyledCalendarModalTitleBar,
  StyledCalendarModalTodayButton,
} from './index.styled'

export type CalendarModalProps = {
  startDate?: Date
  ranges?: CalendarRange[]
  markers?: CalendarMarker[]
  selectedDate?: Date | null
  onClose?: () => void
  onChangeSelectedDate?: (d: Date) => void
  onChangeStartDate?: (d: Date) => void
  renderTooltip?: (d: Date) => JSX.Element
  from?: Date
}

export function CalendarModal({
  startDate = new Date(),
  ranges,
  markers,
  selectedDate,
  onClose,
  onChangeSelectedDate,
  onChangeStartDate,
  renderTooltip,
  from,
}: CalendarModalProps) {
  const { formatMessage: f } = useIntl()

  function handleClickTodayButton() {
    if (onChangeSelectedDate) {
      if (!from || dayjs(from).isBefore(dayjs())) {
        onChangeSelectedDate(new Date())
      }
    }
    if (onChangeStartDate && !dayjs(startDate).isSame(dayjs(), 'year')) {
      onChangeStartDate(new Date())
    }
    setTimeout(() => {
      const modalContent = document.querySelector('.modal__content-wrapper')
      if (modalContent) {
        const el = document.querySelector(
          `[data-month-index="${new Date().getMonth()}"]`,
        )

        el?.scrollIntoView({
          behavior: 'smooth',
        })
      }
    }, 200)
  }

  return (
    <StyledCalendarModal>
      <StyledCalendarModalTitleBar>
        <StyledCalendarModalCloseIcon
          src="/images/close.svg"
          alt=""
          onClick={onClose}
        />

        <Text size="md" type="bold">
          {f(
            { id: 'myHealth.calendar.title' },
            { year: startDate.getFullYear() },
          )}
        </Text>

        <StyledCalendarModalTodayButton
          size="md"
          color="ghost"
          onClick={handleClickTodayButton}
        >
          {f({ id: 'myHealth.calendar.button.today' })}
        </StyledCalendarModalTodayButton>
      </StyledCalendarModalTitleBar>

      <StyledCalendarModalContent className="modal__content-wrapper">
        <StyledCalendarModalCalendar
          mode="yearly"
          start={startDate}
          from={from}
          ranges={ranges}
          markers={markers}
          selected={selectedDate}
          onChangeSelected={onChangeSelectedDate}
          onChangeStart={onChangeStartDate}
          renderTooltip={renderTooltip}
        />
      </StyledCalendarModalContent>
    </StyledCalendarModal>
  )
}
